"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _SessionApiData_api;
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionApiData = void 0;
const viewer_shared_node_tree_1 = require("@shapediver/viewer.shared.node-tree");
class SessionApiData extends viewer_shared_node_tree_1.AbstractTreeNodeData {
    // #endregion Properties (1)
    // #region Constructors (1)
    /**
     * Creates a SessionApi data node.
     *
     * @param _data the data as key- value pairs
     * @param id the id
     */
    constructor(api, id, version) {
        super(id, version);
        // #region Properties (1)
        _SessionApiData_api.set(this, void 0);
        __classPrivateFieldSet(this, _SessionApiData_api, api, "f");
    }
    // #endregion Constructors (1)
    // #region Public Getters And Setters (2)
    get api() {
        return __classPrivateFieldGet(this, _SessionApiData_api, "f");
    }
    set api(value) {
        __classPrivateFieldSet(this, _SessionApiData_api, value, "f");
    }
    // #endregion Public Getters And Setters (2)
    // #region Public Methods (1)
    /**
     * Clones the scene graph data.
     */
    clone() {
        return new SessionApiData(this.api, this.id, this.version);
    }
}
exports.SessionApiData = SessionApiData;
_SessionApiData_api = new WeakMap();
//# sourceMappingURL=SessionApiData.js.map